<app-input-table [formItems]="formItems"></app-input-table>